import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "[mainheader]", -1)
const _hoisted_3 = { class: "page-content__header" }
const _hoisted_4 = {
  class: "page-content__main",
  ref: "main"
}
const _hoisted_5 = {
  key: 1,
  class: "page-content__left-bar"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, "[leftbar]", -1)
const _hoisted_7 = {
  key: 2,
  class: "page-content__sidebar"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "[sidebar]", -1)
const _hoisted_9 = {
  key: 3,
  class: "page-content__multitool"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, "[multitool]", -1)
const _hoisted_11 = {
  key: 4,
  class: "page-content__image-viewer"
}
const _hoisted_12 = {
  key: 5,
  class: "page-content__player"
}
const _hoisted_13 = {
  key: 6,
  class: "page-content__overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page-content", _ctx.classes])
  }, [
    (_ctx.hasMainHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "mainheader", {}, () => [
            _hoisted_2
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref: "internal",
      class: "page-content__body",
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollHandler && _ctx.scrollHandler(...args)))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "header")
      ]),
      _createElementVNode("main", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ], 512)
    ], 544),
    (_ctx.hasLeftBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "left-bar", {}, () => [
            _hoisted_6
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasSidebar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "sidebar", {}, () => [
            _hoisted_8
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasMultitool)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _renderSlot(_ctx.$slots, "multitool", {}, () => [
            _hoisted_10
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasViewer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _renderSlot(_ctx.$slots, "image-viewer")
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasPlayer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _renderSlot(_ctx.$slots, "player")
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasOverlay)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _renderSlot(_ctx.$slots, "overlay")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}